// extracted by mini-css-extract-plugin
module.exports = {"box":"router_box__1XVsl","loading":"router_loading__70qQ7"};